<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="this.dialogRef.close()" >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<mat-card
  class="mat-elevation-z0"
  style="
    padding-bottom: 32px;
    padding: 20px;
    background-color: #f1e2d0 !important;
    max-height: 60vh;
    overflow-y: auto;
  ">
  <div>
    <p class="w-100">
      {{ "TRANSLATE.WHERE_LIKE_DELIVERY" | translate }}
    </p>
  </div>

  <div fxFlex="100" fxFlex.gt-xs="90">
    <div class="row wrap" ngClass.gt-md="m-0">
      <div
        *ngIf=" this.principalAddress.location_two || this.principalAddress.address || this.principalAddress.reference"
        class="flex flex-row"
      >
        <mat-card
          style="background-color: #f5ebdc !important; display: flex; flex-direction: row; align-items: center; padding: 16px;"
          class="light-block"
          [class.light-block-selected]="addressId == '0'"
          (click)="verifyAddress('0')"
        >
          <mat-icon
            class="mat-icon-lg"
            style="margin-right: 10px; color: #502314;"
            [class.text-muted]="addressId != '0'"
          >
            home
          </mat-icon>

          <div style="flex: 1; display: flex; flex-direction: column;">
            <p class="b-title" style="margin: 0;">{{ "TRANSLATE.MAIN" | translate }}</p>
            @if(company && company.addressType == '1'){
            <span style="font-size: 12px; color: red;"
              *ngIf="!zoneObjectPrincipal || zoneObjectPrincipal.bp_locationZoneDelete == '1'; else template2">
              - {{ "TRANSLATE.UPDATE_RESIDENTIAL" | translate }}</span>
            <ng-template #template2>
              <span *ngIf="zoneObjectPrincipal.active == '0'">
                <span style="color: rgb(219, 181, 10);"> {{ "TRANSLATE.UNDER_REVIEW" | translate }}</span></span>

              <span *ngIf="zoneObjectPrincipal.active == '2' ">
                <span style="color:rgb(206, 59, 33)">{{ "TRANSLATE.NO_COVERAGE" | translate}}</span>
              </span>
            </ng-template>
            }
            <span *ngIf="company && ( company.addressType == '0' || (company.addressType == '1' && !(!zoneObjectPrincipal || zoneObjectPrincipal.bp_locationZoneDelete !== '1')) )"
            class="text-muted m-0 b-subtitle">{{ principalAddress.address }}</span>
          </div>

          <button mat-icon-button color="primary" matTooltip="Editar Dirección" (click)="openUpdateAddress()">
            <mat-icon class="mat-18" style="color: #502314">edit</mat-icon>
          </button>
      </mat-card>
      </div>
      <div *ngFor="let item of listAddress">
        <mat-card
          style="background-color: #f5ebdc !important; display: flex; flex-direction: row; align-items: center; padding: 16px;"
          class="light-block"
          [class.light-block-selected]="addressId == item.id"
          (click)="verifyAddress(item)"
        >
          <mat-icon
            class="mat-icon-lg"
            style="margin-right: 10px; color: #502314;"
            [class.text-muted]="addressId != item.id"
          >
            place
          </mat-icon>

          <div class="content" style="flex: 1; display: flex; flex-direction: column;">
            <p class="b-title" style="margin: 0;">{{ item.name }}</p>
            @if(company && company.addressType == '1'){
            <span style="font-size: 12px; color: red;"
                *ngIf="!item.locationZoneActive || item?.locationZoneDelete == '1'; else template3">
                - {{ "TRANSLATE.UPDATE_RESIDENTIAL" | translate }}</span>
            <ng-template #template3>
                <span *ngIf="item.locationZoneActive == '0'">
                  <span style="color: rgb(219, 181, 10);">{{ "TRANSLATE.UNDER_REVIEW" | translate }}</span></span>

                <span *ngIf="item.locationZoneActive == '2'">
                  <span style="color:rgb(206, 59, 33)">{{ "TRANSLATE.NO_COVERAGE" | translate}}</span>
                </span>
            </ng-template>
            }
            <span *ngIf="company && ( company.addressType == '0' || (company.addressType == '1' && !(!item.locationZoneActive || item.locationZoneDelete !== '1')) )"
              class="text-muted m-0 b-subtitle"> {{ item.address }}
            </span>
          </div>
          <div (click)="$event.stopPropagation()">
            <button mat-icon-button color="primary" [matMenuTriggerFor]="menuRef">
              <mat-icon style="color: #502314">more_vert</mat-icon>
            </button>

            <mat-menu #menuRef="matMenu">
              <button mat-menu-item (click)="openNewAddress(item)">
                <mat-icon style="color: #502314" class="mat-18">edit</mat-icon>
                {{ "TRANSLATE.EDIT_ADDRESS" | translate }}
              </button>
              <button mat-menu-item (click)="openDeleteAddress(item)">
                <mat-icon color="warn" class="mat-18">delete</mat-icon>
                {{ "TRANSLATE.DELETE_ADDRESS" | translate }}
              </button>
            </mat-menu>
          </div>
        </mat-card>
      </div>
    </div>

    <div class="row wrap px-3" ngClass.gt-md="m-0">
      <mat-card
        class="light-block flex flex-row py-3"
        [class.light-block-selected]="addressId == 'N'"
        (click)="openNewAddress(null)"
      >
        <mat-icon class="mat-icon-lg m-0" style="margin-right: 10px !important; align-self: center">
          add
        </mat-icon>

        <div class="content flex flex-row">
          <span class="b-title">
            {{ "TRANSLATE.ADD_NEW_ADDRESS" | translate }}
          </span>
        </div>
      </mat-card>
    </div>
  </div>
</mat-card>
